import Cookies from 'universal-cookie';

import { decrypt, encrypt } from './encrypt';

const cookies = new Cookies(null, { path: '/' });

export const setUserToken = (data: ITokenData) =>
  cookies.set('leasing-client-hash', encrypt(JSON.stringify(data)));

export const getUserToken = (): ITokenData => {
  try {
    return cookies.get('leasing-client-hash')
      ? JSON.parse(decrypt(cookies.get('leasing-client-hash')!))
      : { accessToken: '', refreshToken: '' };
  } catch (err) {
    console.error(err);
    return { accessToken: '', refreshToken: '' };
  }
};

export const removeUserToken = () => cookies.remove('leasing-client-hash');

interface ITokenData {
  accessToken: string;
  refreshToken: string;
}
